import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import * as tt from 'io-ts-types';
var Error = t.type({
  message: t.string
});
var CustomFieldBase = t.type({
  categoryID: t.string,
  name: t.string
});
export var CustomFieldText = t.intersection([t.type({
  __typename: t.literal('CustomFieldText'),
  value: nullable(t.string)
}), CustomFieldBase]);
export var CustomFieldPickList = t.intersection([t.type({
  __typename: t.literal('CustomFieldPickList'),
  value: nullable(t.string),
  valueOptions: t.array(t.string)
}), CustomFieldBase]);
export var CustomFieldMultiSelect = t.intersection([t.type({
  __typename: t.literal('CustomFieldMultiSelect'),
  values: t.array(t.string),
  valueOptions: t.array(t.string)
}), CustomFieldBase]);
export var CustomFieldDate = t.intersection([t.type({
  __typename: t.literal('CustomFieldDate'),
  value: nullable(t.string)
}), CustomFieldBase]);
export var CustomFieldFormDate = t.intersection([t.type({
  __typename: t.literal('CustomFieldDate'),
  value: nullable(t.string)
}), CustomFieldBase]);
export var CustomField = t.union([CustomFieldText, CustomFieldPickList, CustomFieldDate, CustomFieldMultiSelect], 'CustomField');
var ImageInput = t.intersection([t.type({
  url: t.string
}), t.partial({
  filestack: nullable(t.type({
    handle: t.string
  }))
})]);
export var UpdateProfileImageInput = t.type({
  input: ImageInput
});
export var UpdateProfileImageOutput = t.type({
  updateProfileImage: t.type({
    __typename: t.literal('UpdateProfileImageOutput'),
    url: t.string
  })
});
export var Language = t.type({
  id: t.string,
  name: t.string,
  code: t.string,
  displayName: t.string
});
export var MemberInfo = t.type({
  id: t.string,
  username: t.string,
  name: t.string,
  email: t.string,
  title: nullable(t.string),
  company: nullable(t.string),
  avatarUrl: nullable(t.string),
  timezone: nullable(t.string),
  language: Language,
  customFields: nullable(t.array(CustomField))
});
var CustomFieldInput = t.partial({
  text: t.type({
    categoryID: t.string,
    value: nullable(t.string)
  }),
  picklist: t.type({
    categoryID: t.string,
    value: nullable(t.number)
  }),
  date: t.type({
    categoryID: t.string,
    value: nullable(tt.date)
  }),
  multiSelect: t.type({
    categoryID: t.string,
    values: nullable(t.array(t.number))
  })
});
export var EditProfileInput = t.type({
  input: t.type({
    name: t.string,
    username: t.string,
    title: nullable(t.string),
    company: nullable(t.string),
    timezone: nullable(t.string),
    language: nullable(t.string),
    customFields: nullable(t.array(CustomFieldInput))
  })
});
export var EditProfileOutput = t.type({
  editProfile: t.union([t.type({
    __typename: t.literal('EditProfileErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditProfileResult'),
    result: MemberInfo
  })])
});